import React from 'react';
import { NavLink } from 'react-router-dom';

const enablePos = String(process.env.REACT_APP_ENABLE_POS || '').toLowerCase() === 'true';

const tabs = [
  { to: '/admin/general', label: 'General' },
  { to: '/admin/reviews', label: 'Reviews' },
  { to: '/admin/discounts', label: 'Discounts' },
  { to: '/admin/theme', label: 'Theme' },
  { to: '/admin/dashboard', label: 'Products' },
  { to: '/admin/audit', label: 'Audit' },
  { to: '/admin/reports/orders', label: 'Reports' },
  { to: '/admin/shipments', label: 'Shipments' },
  ...(enablePos ? [{ to: '/admin/channels/pos', label: 'POS' }] : []),
];

export default function AdminNavTabs() {
  return (
    <nav className="admin-tabs" aria-label="Admin navigation">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) => `admin-tab${isActive ? ' active' : ''}`}
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
